var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", [
      _vm._v(_vm._s(_vm.global.type == "manage" ? "管理端" : "客户端"))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "info_box" }, [
      _c(
        "div",
        { staticClass: "agent" },
        [
          _c(
            "el-select",
            {
              attrs: { size: "", placeholder: "请选择" },
              model: {
                value: _vm.agentValue,
                callback: function($$v) {
                  _vm.agentValue = $$v
                },
                expression: "agentValue"
              }
            },
            _vm._l(_vm.agentOptions, function(item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "name" },
        [
          _c("el-button", { attrs: { type: "text", disabled: "" } }, [
            _vm._v(_vm._s(_vm.username))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "avatar" },
        [
          _c(
            "el-button",
            { attrs: { type: "text" }, on: { click: _vm.toExit } },
            [_vm._v("退出登录")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c833af0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c833af0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderComponent.vue
// module id = null
// module chunks = 